export default __webpack_public_path__ + "static/media/sin-activar.ab671688.svg";